export const constants = {
  PREFIX: 'pixelplay-',
};

export const localStorageLabels = {
  // AUTH_DETAILS: constants.PREFIX + 'auth-details',
  TID: 'tid',
  LOCAL_DATA: 'localData',
  DEVICE_INFO: 'ScreenInfo',
  DEVICE_META: 'screenMeta',
  BUNDLE: constants.PREFIX + 'bundle',
};
